//#region src/core/i18n/text/pip.ts
const prefix = "pip.";
const enterText = {
	key: `${prefix}enter`,
	text: "Enter picture-in-picture"
};
const exitText = {
	key: `${prefix}exit`,
	text: "Exit picture-in-picture"
};
//#endregion
export { enterText, exitText };

//# sourceMappingURL=pip.js.map